import { render, staticRenderFns } from "./LibraryCaseCard.vue?vue&type=template&id=674f4a2e&scoped=true"
import script from "./LibraryCaseCard.vue?vue&type=script&lang=js"
export * from "./LibraryCaseCard.vue?vue&type=script&lang=js"
import style0 from "./LibraryCaseCard.vue?vue&type=style&index=0&id=674f4a2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f4a2e",
  null
  
)

export default component.exports